import { ThemeUICSSObject } from '@apia/theme';
import oneColumnAside from './oneColumnAside';
import portalForm from './portalForm';
import twoColumns from './twoColumns';
import footerResponsiveButtons from './twoColumns/footerResponsiveButtons';
import twoColumnsAside from './twoColumnsAside';
import twoColumnsCentered from './twoColumnsCentered';
import twoColumnsList from './twoColumnsList';
import twoColumnsListOneColumnAside from './twoColumnsListOneColumnAside';
import withToolbar from './withToolbar';
/* IMPORT HERE */

const templates: Record<string, ThemeUICSSObject> = {
  footerResponsiveButtons,
  oneColumnAside,
  portalForm,
  twoColumns,
  twoColumnsCentered,
  twoColumnsList,
  twoColumnsAside,
  twoColumnsListOneColumnAside,
  withToolbar,
  /* PREPEND HERE */
};

export default templates;
